export default __webpack_public_path__ + "static/blogThumbnail(4)-ad724cb62f9fc308f490ee4443075ae8.png";